export const AUTH_TYPE = 'AUTH_TYPE'

export const URBAN_GARDEN_CODE = 'lyon_urban_garden'

export const T1_CODE = 'courbevoie_t1'

export const MELBOURNE_CODE = 'melbourne_freshwater_place'
